const SUNDAY = 0;
const MONDAY = 1;
const THURSDAY = 4;
const SATURDAY = 6;
function pad(n) {
    return n.toString().padStart(2, '0');
}
function formatDateISO(year, month, day) {
    return `${year}-${pad(month)}-${pad(day)}`;
}
/**
 * Returns the day-of-month for the Nth occurrence of `weekday` in a given month.
 * `weekday`: 0 = Sunday, 1 = Monday, ..., 6 = Saturday
 * `n`: 1-based (1 = first, 2 = second, etc.)
 */
function nthWeekdayOfMonth(year, month, weekday, n) {
    const first = new Date(year, month - 1, 1).getDay();
    const day = 1 + ((weekday - first + 7) % 7) + (n - 1) * 7;
    return day;
}
/**
 * Returns the day-of-month for the last occurrence of `weekday` in a given month.
 */
function lastWeekdayOfMonth(year, month, weekday) {
    const lastDay = new Date(year, month, 0).getDate();
    const lastDow = new Date(year, month - 1, lastDay).getDay();
    return lastDay - ((lastDow - weekday + 7) % 7);
}
/**
 * For fixed-date holidays: if the date falls on Saturday, the observed date
 * is the preceding Friday; if Sunday, the following Monday.
 */
function observedDate(year, month, day) {
    const d = new Date(year, month - 1, day);
    const dow = d.getDay();
    if (dow === SATURDAY) {
        d.setDate(d.getDate() - 1);
    }
    else if (dow === SUNDAY) {
        d.setDate(d.getDate() + 1);
    }
    return formatDateISO(d.getFullYear(), d.getMonth() + 1, d.getDate());
}
/**
 * Generates all 11 US federal holidays for a given year, using the
 * official rules (observed-date shifts for fixed-date holidays,
 * Nth-weekday-of-month for floating holidays).
 *
 * If Congress adds a new federal holiday, this function must be updated manually.
 * Cross-check against https://date.nager.at/api/v3/PublicHolidays/{year}/US
 */
export function generateUSFederalHolidays(year) {
    return [
        {
            date: observedDate(year, 1, 1),
            localName: "New Year's Day",
            name: "New Year's Day",
            countryCode: 'US',
        },
        {
            date: formatDateISO(year, 1, nthWeekdayOfMonth(year, 1, MONDAY, 3)),
            localName: 'Martin Luther King, Jr. Day',
            name: 'Martin Luther King, Jr. Day',
            countryCode: 'US',
        },
        {
            date: formatDateISO(year, 2, nthWeekdayOfMonth(year, 2, MONDAY, 3)),
            localName: "Washington's Birthday",
            name: 'Presidents Day',
            countryCode: 'US',
        },
        {
            date: formatDateISO(year, 5, lastWeekdayOfMonth(year, 5, MONDAY)),
            localName: 'Memorial Day',
            name: 'Memorial Day',
            countryCode: 'US',
        },
        {
            date: observedDate(year, 6, 19),
            localName: 'Juneteenth National Independence Day',
            name: 'Juneteenth National Independence Day',
            countryCode: 'US',
        },
        {
            date: observedDate(year, 7, 4),
            localName: 'Independence Day',
            name: 'Independence Day',
            countryCode: 'US',
        },
        {
            date: formatDateISO(year, 9, nthWeekdayOfMonth(year, 9, MONDAY, 1)),
            localName: 'Labour Day',
            name: 'Labor Day',
            countryCode: 'US',
        },
        {
            date: formatDateISO(year, 10, nthWeekdayOfMonth(year, 10, MONDAY, 2)),
            localName: 'Columbus Day',
            name: 'Columbus Day',
            countryCode: 'US',
        },
        {
            date: observedDate(year, 11, 11),
            localName: 'Veterans Day',
            name: 'Veterans Day',
            countryCode: 'US',
        },
        {
            date: formatDateISO(year, 11, nthWeekdayOfMonth(year, 11, THURSDAY, 4)),
            localName: 'Thanksgiving Day',
            name: 'Thanksgiving Day',
            countryCode: 'US',
        },
        {
            date: observedDate(year, 12, 25),
            localName: 'Christmas Day',
            name: 'Christmas Day',
            countryCode: 'US',
        },
    ];
}
/**
 * US Federal Holidays for the current year and next year (auto-generated).
 */
export const US_FEDERAL_HOLIDAYS = [
    ...generateUSFederalHolidays(new Date().getFullYear()),
    ...generateUSFederalHolidays(new Date().getFullYear() + 1),
];
//# sourceMappingURL=holiday.constants.js.map